export default from './BuyerRegistration';



// WEBPACK FOOTER //
// ./src/components/SignUp/components/BuyerRegistration/index.js